/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeNextId = core.serialization.object({
    id: core.serialization.string(),
    label: core.serialization.string().optional(),
    path: core.serialization.string().optional(),
    query: core.serialization.string().optional(),
});
